import { FilterMatchMode } from "primereact/api";
import { PagingConstants } from "./PagingConstants";

export const INITIAL_LAZY_GENERATED_REPORTS_STATE = {
  first: 0,
  rows: PagingConstants.INITIAL_ROW_AMOUNT,
  page: 1,
  sortField: "created",
  sortOrder: -1,
  multiSortMeta: [{ field: "created", order: -1 }],
  filters: {
    version: { value: null, matchMode: FilterMatchMode.CONTAINS },
    created: { value: null, matchMode: FilterMatchMode.DATE_IS },
  },
};
